module.exports = __webpack_public_path__ + "static/media/icon-youtube.d64d9946.svg";